<script lang="ts" setup>
interface Props {
  modelValue: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const emit = defineEmits(['update:modelValue']);

const handleInputChange = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const checked = input.checked;
  // Controlled: the parent owns the value. Without this reset a change the
  // parent declines leaves the DOM checkbox on the value it refused, and the
  // next click then emits the opposite of what the user sees.
  input.checked = props.modelValue;
  emit('update:modelValue', checked);
};
</script>

<template>
  <label
    class="switch"
    :class="{
      'switch--checked': props.modelValue,
      'switch--disabled': props.disabled,
    }"
  >
    <input
      class="switch__input"
      type="checkbox"
      :checked="props.modelValue"
      :disabled="props.disabled"
      @change="handleInputChange"
    />
    <div class="switch__slider"></div>
  </label>
</template>

<style lang="scss" scoped>
.switch {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 20px;
  cursor: pointer;

  .switch__slider {
    background-color: var(--color-gray-200);
  }

  &.switch--checked {
    .switch__slider {
      background-color: var(--color-primary-600);
    }
    .switch__slider::before {
      transform: translateX(20px);
    }
  }

  &.switch--disabled {
    .switch__input {
      cursor: not-allowed;
    }
    .switch__slider {
      background-color: var(--color-gray-200);
    }
  }
}

.switch__input {
  display: none;
}

.switch__slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 10px;
  transition: background-color var(--duration-slow) var(--ease-standard);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
}

.switch__slider::before {
  position: absolute;
  content: '';
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: #fff;
  border-radius: var(--border-radius-circle);
  transition: transform var(--duration-slow) var(--ease-standard);
}
</style>
